<template>
  <FormieForm :handle="handle" :rounded-full="true" />
</template>

<script setup lang="ts">
defineProps({
  handle: { type: String, required: true },
})
</script>
